import React, { useState, useEffect, useRef } from "react";
import { func, object, bool, array, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";
import truncate from "lodash/truncate";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import MobileLogo from "../../atoms/MobileLogo";
import SearchIcon from "../../atoms/icons/search-icon";
import VerticalMenubar from "../VerticalMenubar";

import { setVerticalMenuBar } from "../../helper/actions";
import StoryPageMetaDataIcons from "../../molecules/StoryPageMetaDataIcons";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";

import "./secondaryStoryHeaderTopContent.m.css";

const SecondaryStoryHeaderTopContent = ({
  hamburgerMenu,
  isVerticalMenubar,
  setVerticalMenuBar,
  stickyHeader = false,
  story,
  domainInfo,
  domainSlug = "",
  isVideoStory = false,
  publisherAttributes
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const ref = useRef(null);
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const bgColor = () => {
    switch (domainSlug) {
      case "kishoralo":
        return "#eee";
      case "protichinta":
        return "#fbf6de";
      default:
        return "#eee";
    }
  };

  const fontColor = () => {
    switch (domainSlug) {
      case "kishoralo":
        return "#121212";
      case "protichinta":
        return "#222";
      default:
        return "#222";
    }
  };

  const headline = story.headline
    ? truncate(story.headline, {
        length: 80
      })
    : "";

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={!!isVerticalMenubar}
              isDesktop={isDesktop}
            />
            {isDesktop && showSearchIcon && !stickyHeader && (
              <span styleName="search-icon" onClick={toggleSearchIcon} className="search-icon">
                <SearchIcon domainSlug={domainSlug} />
              </span>
            )}
            {isDesktop && <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>}
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              domainInfo={domainInfo}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
        </div>
        <div styleName="logo">{logoRenderer(<MobileLogo />)}</div>
        <div styleName="story-section" className="domain-story-section">
          <Link href={story.sectionUrl}>{story.section}</Link>
        </div>
        {headline && (
          <div
            styleName={`story-headline ${publisherAttributes.lang === "en" ? "en-headline" : ""}`}
            className="domain-story-headline"
          >
            {headline}
          </div>
        )}
        <StoryPageMetaDataIcons color1={bgColor()} color2={fontColor()} isVideoStory={isVideoStory} />
      </div>
    </div>
  );
};

SecondaryStoryHeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  menu: array,
  stickyHeader: bool,
  story: object,
  collection: object,
  sections: array,
  domainInfo: object,
  hamburgerMenu: array,
  domainSlug: string,
  isVideoStory: bool,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
    storyHeadline: get(state, ["qt", "data", "story", "headline"], ""),
    story: get(state, ["headerReducer", "showStoryHeader"], ""),
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryStoryHeaderTopContent);
